const Source = ['web', 'app']

export default Source;